module.exports = __webpack_public_path__ + "static/media/qualification-3.30be2fb1.svg";